<script>
    import {Doughnut} from 'vue-chartjs'

    export default {
        extends: Doughnut,
        mounted() {
            this.renderChart({
                labels: ['Chile', 'Otros'],
                datasets: [
                    {
                        backgroundColor: [
                            '#41B883',
                            '#E46651'
                        ],
                        data: [99.7, 0.3]
                    }
                ]
            }, {responsive: true, maintainAspectRatio: true})
        }
    }
</script>
